<template>
    <div class="static-heaer" style="margin-bottom: 20px">

        <div class="item-header2">
            <p style="font-size: 1.3rem; line-height: 2.3rem; margin-top: 20px; padding: 0 10px; text-align: justify" data-aos="zoom-in">En tal sentido, LA CÁMARA, VESTUARIO, AUDIO, Y LENGUAJE NO VERBAL son ALIADOS ESTRATEGICOS en el ejercicio de la Telemedicina y la telesalud. .<br><br>
                En vista de que, como profesionales de la salud y afines, deseamos siempre ofrecer lo mejor y nos esforzamos en capacitarnos cada día para brindar la excelencia en nuestro desempeño, hemos creado para ti, que estás dispuesto a aprender y explorar la TELEMEDICINA Y TELESALUD como la vía de expansión profesional y personal al nivel jamás soñado!, un taller teórico práctico 100% en línea que hará en sus participantes, una trasformación comunicacional INCREIBLE!
              <br><br>

            </p>
            <div style="display: flex; justify-content: center; margin-top: 10px; text-align: center; flex-direction: column; align-items: center; z-index: 2; margin-bottom: 20px">
                <h2 style="font-weight: bold">INVERSIÓN: 137$</h2>
                <a href="https://cambiandotusalud.com/checkout/137/a79cd41a617c3901f4e9759b99cee2935d674e080650e253f1d8f598b0bddc35" target="_blank" style="width: 260px; height: 90px; background-color: #FF4500; border: solid 1px white; border-radius: 10px; color: white; font-weight: 700;  cursor: pointer; font-size: 1.5rem; align-items: center; display: flex; justify-content: center">INSCRIBETE ÁQUI!</a>
            </div>
            <div class="item-header2" style="font-size: 1.3rem; line-height: 2.3rem; padding: 0 10px; text-align: justify" data-aos="zoom-in">
                El TALLER COMUNICACIONES EFECTIVAS EN TELEMEDICINA es un intensivo de 3 días, en el cual abordaremos de manera teórico (videos asincrónicos, y tareas) y practicas (sesiones en vivo de preguntas y respuestas y evaluación practica de asignaciones) donde exploraremos los siguientes tópicos:
            </div>
        </div>
        <div class="item-header">
            <div style="font-size: 1.6rem; font-weight: 800; margin-bottom: 5px">FACILITADORES:</div>
            <div class="profesor-image">
                <div style="width: 20%">
                    <img src="/image/profile/telemedicina-03.png" width="100%"/>
                </div>
                <div class="text-profesor">
                    <span style="font-size: 1.5rem; font-weight: 800">Dra. Omidres Pérez de Carvelli</span><br>
                    Médico cirujano especialista en medicina interna, endocrinología y metabolismo, coach en salud y bienestar, conferencista, diplomado en docencia, investigadora, escritora, emprendedora digital
                </div>
            </div>
            <div class="profesor-image">
                <div style="width: 20%">
                    <img src="/image/profile/telemedicina-04.png" width="100%"/>
                </div>
                <div class="text-profesor">
                    <span style="font-size: 1.5rem; font-weight: 800">Dr. Miguel José Guevara H. </span><br>
                    Médico Cirujano, Especialista en Gerencia de Salud y Desarrollo Humano, <span style="font-weight: 800">Magister en Terapia de la Conducta</span>, diplomado en Gerencia Moderna de Salud, Coaching Neurointegrativo, Habilidades Gerenciales, Componente Docente en Entornos Virtuales, Salud Ocupacional.
                </div>

            </div>

        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import formLanding from './../resources/formLandingEvent.vue'
    export default {
        name: '',
        components: {
            formLanding
        },
        created(){

        },
        data(){
            return {
                showModal: false
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>
    .profesor-image{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        margin: 20px 0;
    }
    .text-profesor{
        font-size: 1rem; width: 80%
    }
    .static-heaer{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        background-color: #EEF3F9;
        height: auto;
        background-size: cover;
        margin-bottom: 10px;
        overflow-x : hidden;
        overflow-y : hidden
    }
    .item-service{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
    }
    .item{
        width: 50%;
        padding: 15px;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: justify;
        color: #191f4d;
    }
    .item p{
        font-size: 1rem
    }
    .item-header{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        align-items: flex-start;
        font-size: 1.8rem;
        font-weight: 800;
        padding: 40px;
        text-align: center;
        margin-top: -10px;
        background-color: #DBE6F2;
    }
    .item-header2{
        flex: 1;
        display: flex;
        flex-direction: column;
        font-weight: 700;
        justify-content: flex-start;
        line-height: 2.7rem;
        /*font-family: 'Gayathri', sans-serif;*/
        text-align: center;
        padding: 0 15px;
        margin-top: 30px;
    }
    .b-title{
        font-size: 8rem;
        line-height: 7rem;
        font-weight: 800
    }
    .b-title2{
        font-size: 3rem;
        font-weight: 800
    }
    @media (min-width: 1281px) {

    }

    @media (min-width: 1025px) and (max-width: 1280px) {

    }
    @media (min-width: 768px) and (max-width: 1024px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #EEF3F9;
            height: auto;
            background-size: cover;

            overflow-x : hidden;
            overflow-y : hidden
        }
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    @media (min-width: 481px) and (max-width: 767px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #EEF3F9;
            height: auto;
            background-size: cover;

            overflow-x : hidden;
            overflow-y : hidden
        }
    }

    @media (min-width: 10px) and (max-width: 480px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #EEF3F9;
            height: auto;
            background-size: cover;

            overflow-x : hidden;
            overflow-y : hidden
        }
        .item-service{
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;

        }
        .item{
            width: 100%;

        }
    }
</style>